import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/index.vue'
import Layout from '../components/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/table',
    name: 'table',
    component: () => import('../views/template/table.vue')
  },
  //项目现场实时
  {
    path: '/getewayRealInfo',
    name: 'getewayRealInfo',
    component: () => import('../views/projectScene/getewayRealInfo.vue'),
    meta: {
      title: '组态'
    }
  },
  //项目现场实时3D
  {
    path: '/getewayRealInfo_3D',
    name: 'getewayRealInfo_3D',
    component: () => import('../views/projectScene/getewayRealInfo_3D.vue'),
    meta: {
      title: '组态'
    }
  },
  // //实时数据
  // {
  //   path: '/realData',
  //   name: 'realData',
  //   component: () => import('../views/projectScene/realData.vue'),
  //   meta: {
  //     title: '控制'
  //   }
  // },
  // //告警
  // {
  //   path: '/alert',
  //   name: 'alert',
  //   component: () => import('../views/projectScene/alert.vue'),
  //   meta: {
  //     title: '告警'
  //   }
  // },
  // //趋势图
  // {
  //   path: '/TrendChart',
  //   name: 'TrendChart',
  //   component: () => import('../views/projectScene/TrendChart.vue'),
  //   meta: {
  //     title: '趋势图'
  //   }
  // },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: '/login',//登录页
    children:[
      //首页
      {
        path: 'home',
        name: 'home',
        component: () => import('../views/home.vue')
      },
      //项目现场
      {
        path: 'projectScene',
        name: 'projectScene',
        component: () => import('../views/projectScene/index.vue')
      },
      //项目现场数据
      {
        path: 'gatewayData',
        name: 'gatewayData',
        component: () => import('../views/projectScene/gatewayData.vue')
      },
      //项目现场详细信息
      {
        path: 'detailInfo',
        name: 'detailInfo',
        component: () => import('../views/projectScene/detailInfo.vue')
      },
      //通知/告警
      {
        path: 'notice',
        name: 'notice',
        component: () => import('../views/notice/index.vue')
      },
      //地图
      {
        path: 'map',
        name: 'map',
        component: () => import('../views/map/index.vue')
      },
      //通知/日志
      {
        path: 'log',
        name: 'log',
        component: () => import('../views/notice/log.vue')
      },
      //设备模板
      {
        path: 'template',
        name: 'template',
        component: () => import('../views/template/index.vue'),
      },
      //模板详情
      {
        path: 'templateDetail',
        name: 'templateDetail',
        component: () => import('../views/template/templateDetail/index.vue'),
      },
      //新增模板
      {
        path: 'addTemplate',
        name: 'addTemplate',
        component: () => import('../views/template/addTemplate/index.vue'),
      },
      {
        path: 'Preview',
        name: 'Preview',
        component: () => import('../views/template/addTemplate/Preview.vue'),
      },
      //派工维修
      {
        path: 'repair',
        name: 'repair',
        redirect:'/repair/repaircheck',
        component: () => import('../views/repair/index.vue'),
        children:[
          //报修审核
          {
            path: 'repaircheck',
            name: 'repaircheck',
            component: () => import('../views/repair/repaircheck/index.vue')
          },
          //维修管理
          {
            path: 'faultmanage',
            name: 'faultmanage',
            component: () => import('../views/repair/faultmanage/index.vue')
          },
           //故障管理
           {
            path: 'Dispatchmanage',
            name: 'Dispatchmanage',
            component: () => import('../views/repair/Dispatchmanage/index.vue')
          },
          //统计列表
          {
            path: 'repairlist',
            name: 'repairlist',
            component: () => import('../views/repair/repairlist/index.vue')
          },
        ]
      },
      //用户权限
      {
        path: 'userJurisdiction',
        name: 'userJurisdiction',
        redirect:'/userJurisdiction/user',
        component: () => import('../views/userJurisdiction/index.vue'),
        children:[
           //用户管理
           {
            path: 'user',
            name: 'user',
            component: () => import('../views/userJurisdiction/user/index.vue')
          },
          //角色管理
          {
            path: 'role',
            name: 'role',
            component: () => import('../views/userJurisdiction/role/index.vue')
          },
          //部门管理
          {
            path: 'dept',
            name: 'dept',
            component: () => import('../views/userJurisdiction/dept/index.vue')
          },
          //岗位管理
          {
            path: 'post',
            name: 'post',
            component: () => import('../views/userJurisdiction/post/index.vue')
          },
          //inhand账号管理
          {
            path: 'inhandUserInfo',
            name: 'inhandUserInfo',
            component: () => import('../views/userJurisdiction/inhandUserInfo/index.vue')
          },
          //DM账号管理
          {
            path: 'DMInfo',
            name: 'DMInfo',
            component: () => import('../views/userJurisdiction/DMInfo/index.vue')
          },
        ]
      },
      //建议反馈
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('../views/feedback/index.vue'),
      },
    ]
  },
  {
    path:'/login',
    name:'Login',
    component:Login
  },
  {
    path:'/phone',
    name:'phone',
    component:() => import('../views/phone/index.vue')
  },
] 

const router = new VueRouter({
  routes:routes,
  // base:'/www',
  // mode:'history'
})

export default router
